<ng-template ng-template #feedbackModal let-modal>
  <div id="feedbackContainer">
    <div class="modal-header border-bottom-0 p-4">
      <h5 class="modal-title">{{'TEST.25.SATISFACTIONSURVEY.TITLE' | translate}}</h5>
      <div id="closeModal">
        <button type="button" class="close color-tertiary" aria-label="Close" (click)="modal.dismiss('Cross click')">
          <span aria-hidden="true">&times;</span>&nbsp;
        </button>
      </div>
    </div>

    <div class="modal-body px-4 py-0">
      <form [formGroup]="feedbackForm">
        <div class="form-row">
          <div class="col-12"> {{'TEST.25.SATISFACTIONSURVEY.DESCRIPTION.QUESTION' | translate}}</div>
          <div class="col-3">
            <label class="checkcontainer">
              <input type="radio" formControlName="score" [value]=1>
              <span class="feedbackCheck sadFace"></span>
            </label>
          </div>
          <div class="col-3">
            <label class="checkcontainer">
              <input type="radio" formControlName="score" [value]=2>
              <span class="feedbackCheck neutralFace"></span>
            </label>
          </div>
          <div class="col-3">
            <label class="checkcontainer">
              <input type="radio" formControlName="score" [value]=3>
              <span class="feedbackCheck happyFace"></span>
            </label>
          </div>
          <div class="col-3">
            <label class="checkcontainer">
              <input type="radio" formControlName="score" [value]=4>
              <span class="feedbackCheck heartFace"></span>
            </label>
          </div>
        </div>
        <div class="form-row mt-3 mb-5 optionalRow position-relative">
          <label class="d-block" for="comment" innerHTML="{{'TEST.25.SATISFACTIONSURVEY.DESCRIPTION.OPTIONALINFO' | translate}}"></label> <span class="position-absolute bottom-0 right-0 mr-3 my-1">{{feedbackForm.get('comment').value?.length || 0}}/250</span>
          <textarea class="d-block w-100" formControlName="comment" name="comment" id="comment" cols="30" rows="3" placeholder="{{'TEST.25.SATISFACTIONSURVEY.DESCRIPTION.DETAIL' | translate}}" maxlength="250"></textarea>
        </div>
      </form>
    </div>
    <div class="modal-footer justify-content-center p-4 border-0">
      <button (click)="onSubmit()" class="btn btn-primary w-100 p-3" [disabled]="this.feedbackForm.invalid">{{ 'COMMON.SEND' | translate }}</button>
    </div>
  </div>
</ng-template>
